import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import StepConnector, {
	stepConnectorClasses,
} from '@mui/material/StepConnector';
import './horizontalstepper.scss';
import Check from '@mui/icons-material/Check';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/system';
import { useMediaQuery } from '@mui/material';
const steps = [
	{
		label: 'Step1',
		description: 'Select Base Image',
	},
	{
		label: 'Step2',
		description: 'Image Details',
	},
	{
		label: 'Step3',
		description: 'status',
	},
];
const QontoConnector = styled(StepConnector)(({ theme }) => ({
	[`&.${stepConnectorClasses.alternativeLabel}`]: {
		top: 10,
		left: 'calc(-50% + 16px)',
		right: 'calc(50% + 16px)',
	},
	[`&.${stepConnectorClasses.active}`]: {
		[`& .${stepConnectorClasses.line}`]: {
			borderColor: '#42C3FD',
		},
	},
	[`&.${stepConnectorClasses.completed}`]: {
		[`& .${stepConnectorClasses.line}`]: {
			borderColor: '#42C3FD',
		},
	},
	[`& .${stepConnectorClasses.line}`]: {
		borderColor:
			theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#3E3F51',
		borderTopWidth: 4,
		borderRadius: 1,
	},
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
	backgroundColor:
		theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#3E4A6B',
	zIndex: 1,
	color: '#fff',
	width: 25,
	height: 25,
	display: 'flex',
	borderRadius: '50%',
	justifyContent: 'center',
	alignItems: 'center',
	marginLeft: '-3px',
	...(ownerState.active && {
		backgroundColor: '#7B8AFA',
		boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
	}),
	...(ownerState.completed && {
		backgroundImage:
			'linear-gradient( 136deg,  #43C6FE 0%,  #43C6FE 50%, #338FEE 100%)',
	}),
}));
ColorlibStepIcon.propTypes = {
	/**
	 * Whether this step is active.
	 * @default false
	 */
	active: PropTypes.bool,
	className: PropTypes.string,
	/**
	 * Mark the step as completed. Is passed to child components.
	 * @default false
	 */
	completed: PropTypes.bool,
	/**
	 * The label displayed in the step icon.
	 */
	icon: PropTypes.node,
};
function ColorlibStepIcon(props) {
	const { active, completed, className } = props;

	return (
		<ColorlibStepIconRoot
			ownerState={{ completed, active }}
			className={className}
		>
			{completed ? (
				<Check className="QontoStepIcon-completedIcon" />
			) : (
				<div className="QontoStepIcon-circle" />
			)}
		</ColorlibStepIconRoot>
	);
}
function HorizontalLinearStepper(props) {
	const theme = useTheme();
	const [activeStep, setActiveStep] = React.useState(0);

	// const isMobile = useMediaQuery(theme.breakpoints.down("xs"), {
	//   defaultMatches: true,
	// });

	return (
		// <Stepper
		//   activeStep={props.activeStep}
		//   orientation="horizontal"
		//   className="horizontal_stepper"
		//   connector={<QontoConnector />}
		// >
		//   {props.steps.map((step, index) => (
		//     <Step key={step.label} StepIconComponent={ColorlibStepIcon}>
		//       <StepLabel>
		//         {step.label} <br /> {step.description}
		//       </StepLabel>
		//     </Step>
		//   ))}
		// </Stepper>
		<Stepper
			activeStep={props.activeStep}
			orientation="horizontal"
			className={
				props.page === 'createsession'
					? 'horizontal_stepper_createsession'
					: 'horizontal_stepper'
			}
			connector={<QontoConnector />}
		>
			{props.steps.map((step, index) => (
				<Step key={step.label}>
					<StepLabel StepIconComponent={ColorlibStepIcon}>
						{step.label} <br /> {step.description}
					</StepLabel>
				</Step>
			))}
		</Stepper>
	);
}
export default HorizontalLinearStepper;
